import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SkeletonLoader from "../../components/SkeletonLoader";
import PullToRefresh from "react-pull-to-refresh";
import { listSchedule } from "../../Api";

// Function to parse Indonesian date format (dd-MMM-yyyy) into JavaScript Date
const parseDateWithIndonesianMonth = (dateString) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    Mei: "05",
    Jun: "06",
    Jul: "07",
    Agu: "08",
    Sep: "09",
    Okt: "10",
    Nov: "11",
    Des: "12",
  };

  const [day, month, year] = dateString.split("-");
  const normalizedMonth = months[month];
  if (!normalizedMonth) return null; // Invalid month

  return new Date(`${year}-${normalizedMonth}-${day}`);
};

function Schedules({ dateRange }) {
  const [scheduled, setScheduled] = useState(null);
  const [requested, setRequested] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [activeTab, setActiveTab] = useState("scheduled");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchOnceRef = useRef(false);
  const navigate = useNavigate();

  const fetchSchedules = async () => {
    setLoading(true);
    try {
      const data = await listSchedule();
      // console.log("Scheduled Data:", data.scheduled); // Debug API data
      setScheduled(data.scheduled);
      setRequested(data.requested);
    } catch (err) {
      setError("Failed to fetch schedule data");
    } finally {
      setLoading(false);
    }
  };

  const filterSchedules = () => {
    if (!scheduled) return;

    if (!dateRange) {
      // If no filter is applied, show all schedules
      setFilteredData(scheduled);
      return;
    }

    const today = new Date();
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + dateRange);

    const filtered = {};
    Object.keys(scheduled).forEach((monthYear) => {
      const filteredItems = scheduled[monthYear].filter((schedule) => {
        const scheduleDate = parseDateWithIndonesianMonth(schedule.tgl_service);
        return scheduleDate && scheduleDate >= today && scheduleDate <= futureDate;
      });

      if (filteredItems.length > 0) {
        filtered[monthYear] = filteredItems;
      }
    });

    setFilteredData(filtered);
  };

  useEffect(() => {
    if (fetchOnceRef.current) return;
    fetchOnceRef.current = true;
    fetchSchedules();
  }, []);

  useEffect(() => {
    filterSchedules();
  }, [scheduled, dateRange]);

  const handleItemClick = (item) => {
    navigate(`/schedule-detail/${item.id}`, { state: { item } });
  };

  const handleRefresh = async () => {
    await fetchSchedules();
  };

  const renderSchedules = (data, type) => {
    if (!data || Object.keys(data).length === 0) {
      return (
        <p className="infotext">
          {type === "scheduled"
            ? "Anda Belum memiliki Jadwal Servis"
            : "Anda Belum memiliki Permintaan Servis"}
        </p>
      );
    }
  
    return Object.keys(data).map((monthYear) => (
      <div key={monthYear} className="schedule-group">
        <h3 className="month-header">{monthYear}</h3>
        <div className="item-list">
          {data[monthYear].map((schedule, index) => {
            // Safely handle tgl_service and tgl_request
            const dateField = type === "scheduled" ? schedule.tgl_service : schedule.tgl_request;
            const dateParts = dateField ? dateField.split("-") : ["", "", ""];
  
            return (
              <div
                key={`${schedule.id}-${index}`}
                className="item"
                onClick={() => handleItemClick(schedule)}
              >
                <div className="item-date">
                  <span className="item-day">{dateParts[0]}</span>
                  <span className="item-month">{dateParts[1]}</span>
                  <span className="item-year">{dateParts[2]}</span>
                </div>
                <div className="item-content">
                  <h3 className="item-title">{schedule.ac?.nama_ac || "Unknown AC"}</h3>
                  <p className="item-description">
                    {schedule.tipe_pengerjaan || "No Description"}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ));
  };
  
  return (
  
      <div className="schedulespage">
        {loading ? (
          <div>
            <SkeletonLoader count={3} height={50} />
            <SkeletonLoader count={5} height={30} />
          </div>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <>
            <div className="tribox_tabs">
              <button
                className={`tab ${activeTab === "scheduled" ? "active" : ""}`}
                onClick={() => setActiveTab("scheduled")}
              >
                Scheduled
              </button>
              <button
                className={`tab ${activeTab === "requested" ? "active" : ""}`}
                onClick={() => setActiveTab("requested")}
              >
                Requested
              </button>
            </div>
            <div className="tab-content">
              {activeTab === "scheduled"
                ? renderSchedules(filteredData || scheduled, "scheduled")
                : renderSchedules(requested, "requested")}
            </div>
          </>
        )}
      </div>
  
  );
}

export default Schedules;
